import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import type { ConditionItem } from '../../types/conditions.types'

export type ConditionProps = {
	condition: ConditionItem
	menuOptions: Option[]
}

export const Condition = ({ condition, menuOptions }: ConditionProps) => {
	const { t } = useTranslation()

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{condition.name}</p>
				<ContextMenu
					dataId={condition.id}
					item={condition}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: condition.name })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail label={t('Products')} value={condition.products_count} />
			</dl>
		</li>
	)
}
